<template>
    <div class="w-full h-full flex  antialiased text-slate-400 bg-neutral-950 ">
        <div class="w-full h-full">
            <div class="w-full h-[calc(100vh)]">
                <div class="h-full w-full">
                    Construyendo la seccion de: Videos
                    <p>-{{ token }}-</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script> 
//import axios from 'axios';
import axiosInstance from '../axiosInstance';


export default {
    components: {   },
    data() {
        return {
            token: '', 
        };
    },
    
    methods: { 
        loadClient () {
            //const clientId = { id:this.mLoginInput.toLowerCase() };
            const dataParameters = {
                token: this.token, 
            };
            axiosInstance.post("/api/user", dataParameters)
            .then(response => {
                if (response.data) {
                    console.log(response.data);
                    if(response.data.error == true){
                        if(response.data.error == true) console.log("El canal no existe.");
                            console.log("Error al obtener el usuario: "+response.data.error);
                    } else {
                        console.log("Usuario encontrado");
                        localStorage.setItem('clientData', JSON.stringify(response.data.user));
                        localStorage.setItem('token', this.token);
                        console.log(JSON.parse(localStorage.getItem('clientData')));
                        this.$router.push({ name: 'dashboard' })
                    }
                }else{
                        console.log("AXIOS---no_response");
                }
            })
            .catch(error => {
                console.error("conectados: There was an error!", error);
            }); 
        },
    },
    mounted() {
        console.log("LoginAuto=====");
        const tokenId = this.$route.params.token;
        console.log(tokenId);
        this.token = tokenId; 
        this.loadClient();
        
    }
};
</script>S

<style>

</style>